<div class="email-wrapper">
  <div class="global-icon email-icon" aria-hidden="true"></div>

  <input
    [(ngModel)]="value"
    (blur)="onTouch()"
    class="email-input"
    type="email"
    placeholder="Email@domaine.com"
    [disabled]="disable === true"
    [ngClass]="{ disabled: disable }"
  />
</div>
